/** `aiOperations` namespace keys explaining a disabled 「运行符合条件的广告活动」. */
export type RunEligibleReasonKey = "page.runDisabledAiOff" | "page.runDisabledScope";

export interface RunEligibleGate {
  disabled: boolean;
  /** Null while the button is enabled, or while the dashboard summary is still loading. */
  reasonKey: RunEligibleReasonKey | null;
}

/**
 * Whether the manual bulk run may start, and why not. A native disabled button
 * shows no tooltip, so the page wraps it with the reason (UnavailableControl).
 *
 * - AI master switch off: nothing would run whatever the scope, so it comes first.
 * - Aggregated scope (ADP-110): the bulk trigger endpoint is single-shop
 *   (X-Shop-Id header), so the scope must name exactly one shop.
 * - Summary still loading: disabled, but there is nothing to explain yet.
 */
export function runEligibleGate({
  aiMasterOn,
  aggregate,
}: {
  aiMasterOn: boolean | undefined;
  aggregate: boolean;
}): RunEligibleGate {
  if (aiMasterOn === false) return { disabled: true, reasonKey: "page.runDisabledAiOff" };
  if (aggregate) return { disabled: true, reasonKey: "page.runDisabledScope" };
  if (aiMasterOn === undefined) return { disabled: true, reasonKey: null };
  return { disabled: false, reasonKey: null };
}
